import autosize from 'autosize';

export default function() {
    //Do yo JAHVAHSCRIPT here.

    //set default mobile menu state
    $('body').addClass('menu-is-closed');

    //set default menu slide timing
    const slideTimer = 300;

    //mobile nav button controller
    $('.mobile-nav-trigger').on('click', function () {
        $(this).toggleClass('active');
        $('nav.nav').slideToggle(slideTimer,function () {
            $('body').toggleClass('menu-is-open menu-is-closed');
        });
    });

    //mobile menu auto-close on menu link click controller
    $('.navbar-link, .sidebar-title a').on('click', function (event) {
        $('.mobile-nav-trigger').removeClass('active');
        $('nav.nav').slideUp(100,function () {
            $('body').toggleClass('menu-is-open menu-is-closed');
        });

        event.preventDefault();

        var target = $(this.hash);
        var offset = 20;

        if (target.length) {
            $('html, body').animate({
                scrollTop: target.offset().top - offset
            }, 1000);
        }
    });

    //mobile menu auto-close when clicking outside header and nav
    $(document).on('click', function (event) {
        if ( !$(event.target).closest('header.header').length
            && !$(event.target).closest('nav.nav').length
            && !$(event.target).hasClass('mobile-nav-trigger')) {
                menuAutoClose(slideTimer);
        }
    });

    // If screen is resized, reveal the desktop menu
    // if the screen width is at proper threshold
    $( window ).resize(function () {
        menuAutoClose(0);
        hideShowDesktopMenu();
    });

    //isolate keyboard tab cycle from last mobile menu link back to menu button
    $('.navbar-title:last-of-type .navbar-link').on('blur', function () {
        $('#logo-home').focus();
    });

	autosize($('textarea'));

    //search logic
    $('.search-btn-trigger').on('click', function () {
        $('.search-container').slideDown(500);
        $('.search-container input').focus();
        $('body').addClass('overflow-hidden');
    });

    $('.exit-search').on('click', function () {
        $('.search-container').slideUp(500);
        $('body').removeClass('overflow-hidden');
    });
}

// TODO: Editor JS only?
// This is for duplicator plugin feature for wp-admin users
const duplicatePageButtons = document.getElementsByClassName('m4c-duplicate-post');
document.addEventListener('click', event => {
    if(event.target.matches('.m4c-duplicate-post')) {
        // Prevent additional clicks on the buttons while the page submits the cloning request and reloads
        for(const button of duplicatePageButtons) {
            button.style.pointerEvents = 'none';
        }
    }
});

/**
 * If someone closes the mobile menu then expands the screen width (tricksy hobbitses)
 * then we need to display the desktop menu again, otherwise it stays hidden
 */
function hideShowDesktopMenu() {
    const breakpointLarge = 991;

    let currentWindowWidth = $(window).width();

    if (currentWindowWidth > breakpointLarge) {
        $('nav.nav').css('display', 'flex');
    }
    else {
        $('nav.nav').css('display', 'none');
    }
}

function menuAutoClose(slideTimer) {
    if ( $('body').hasClass('menu-is-open') ) {
        $('.mobile-nav-trigger').removeClass('active');
        $('nav.nav').slideUp(slideTimer, function () {
            $('body').toggleClass('menu-is-open menu-is-closed');
        });
    }
}